import Splide from "@splidejs/splide";

const IFRAME_ALLOW =
  "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen";

const buildYoutubeUrl = (videoId) => {
  const params = new URLSearchParams({
    autoplay: "1",
    rel: "0",
    modestbranding: "1",
    controls: "1",
    autohide: "1",
    playsinline: "1",
    iv_load_policy: "3",
    fs: "0",
    origin: window.location.origin,
  });

  return `https://www.youtube.com/embed/${encodeURIComponent(videoId)}?${params.toString()}`;
};

const buildVimeoUrl = (videoId) => {
  const params = new URLSearchParams({
    autoplay: "1",
    title: "0",
    byline: "0",
    portrait: "0",
  });

  return `https://player.vimeo.com/video/${encodeURIComponent(videoId)}?${params.toString()}`;
};

const revealVideoContainer = (media, container) => {
  container.hidden = false;
  media.classList.add("is-playing");
  // Ensure the iframe is visible before assigning src so autoplay is allowed.
  void container.offsetHeight;
};

const loadAutoplayIframe = (iframe, url) => {
  const nextIframe = document.createElement("iframe");

  for (const attr of [
    "id",
    "class",
    "title",
    "data-video-provider",
    "data-video-id",
  ]) {
    const value = iframe.getAttribute(attr);
    if (value) {
      nextIframe.setAttribute(attr, value);
    }
  }

  nextIframe.setAttribute("data-carousel-video-iframe", "");
  nextIframe.setAttribute("allow", IFRAME_ALLOW);
  nextIframe.setAttribute("allowfullscreen", "");
  nextIframe.src = url;
  iframe.replaceWith(nextIframe);

  return nextIframe;
};

const playVideo = (iframe, provider, videoId, media, container) => {
  revealVideoContainer(media, container);

  const url =
    provider === "youtube" ? buildYoutubeUrl(videoId) : buildVimeoUrl(videoId);

  loadAutoplayIframe(iframe, url);
};

const initVideoSlides = (root) => {
  const triggers = root.querySelectorAll("[data-carousel-video-trigger]");

  triggers.forEach((trigger) => {
    trigger.addEventListener("click", () => {
      const media = trigger.closest("[data-carousel-media]");
      const container = media
        ? media.querySelector("[data-carousel-video-container]")
        : null;
      const iframe = container
        ? container.querySelector("[data-carousel-video-iframe]")
        : null;
      const provider = iframe
        ? iframe.getAttribute("data-video-provider")
        : null;
      const videoId = iframe ? iframe.getAttribute("data-video-id") : null;

      if (!media || !container || !iframe || !provider || !videoId) {
        return;
      }

      playVideo(iframe, provider, videoId, media, container);
    });
  });
};

const initCarousel = (carouselRoot) => {
  const splideElement = carouselRoot.querySelector("[data-carousel-splide]");
  if (!splideElement) {
    return;
  }

  const slides = splideElement.querySelectorAll(".splide__slide");
  if (slides.length > 1) {
    const slider = new Splide(splideElement, {
      type: "slide",
      perPage: 1,
      perMove: 1,
      arrows: true,
      pagination: true,
      rewind: true,
      drag: true,
      speed: 500,
    });

    slider.mount();
  } else {
    splideElement.classList.add("splide--single");
  }

  initVideoSlides(carouselRoot);
};

const init = () => {
  const carousels = document.querySelectorAll("[data-element-carousel]");
  if (!carousels.length) {
    return;
  }

  carousels.forEach((carousel) => initCarousel(carousel));
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}

export default init;
